import AppIcon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const CampaignOverview = ({ campaigns }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-foreground">نظرة عامة على الحملات</h2>
            <p className="text-sm text-muted-foreground mt-1">أداء حملات الإيميل التلقائية</p>
          </div>
          <AppIcon name="BarChart" size={24} className="text-primary" />
        </div>
      </div>

      <div className="divide-y divide-border">
        {campaigns?.map(campaign => {
          const deliveryRate = ((campaign?.delivered / campaign?.sent) * 100)?.toFixed(1);
          const openRate = ((campaign?.opened / campaign?.delivered) * 100)?.toFixed(1);
          const clickRate = ((campaign?.clicked / campaign?.opened) * 100)?.toFixed(1);

          return (
            <div key={campaign?.id} className="p-6 hover:bg-muted/30 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-10 h-10 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: `${campaign?.color}20` }}
                  >
                    <AppIcon name={campaign?.icon} size={20} color={campaign?.color} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">{campaign?.name}</h3>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {formatNumber(campaign?.sent?.toString())} إيميل مُرسل
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 bg-success/10 text-success rounded-full text-xs font-medium">
                  نشط
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <AppIcon name="CheckCircle" size={16} className="text-success" />
                    <span className="text-xs text-muted-foreground">معدل التسليم</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{deliveryRate}%</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {formatNumber(campaign?.delivered?.toString())} مُسلّم
                  </p>
                </div>

                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <AppIcon name="Eye" size={16} className="text-accent" />
                    <span className="text-xs text-muted-foreground">معدل الفتح</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{openRate}%</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {formatNumber(campaign?.opened?.toString())} مفتوح
                  </p>
                </div>

                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <AppIcon name="MousePointer" size={16} className="text-secondary" />
                    <span className="text-xs text-muted-foreground">معدل النقر</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{clickRate}%</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {formatNumber(campaign?.clicked?.toString())} نقرة
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignOverview;